import React, { useState, useEffect, memo } from 'react';
import { Modal, Upload, Button, Skeleton } from 'antd';
import { API } from '@service';
import alert from './alert';
import {
  getImageUploadClientError,
  IMAGE_UPLOAD_ACCEPT,
} from '@utils/imageUploadValidation';

function UploadAndViewImage(props) {
  const propFileName = props.value ? props.value : null;
  const { changeImageLink, handleStatus, uploadAPI = API.uploadIMG } = props;
  const [hasUploaded, setHasUploaded] = useState(Boolean(props.value));
  const [showUpload, setShowUpload] = useState(false);
  const [isFetching, toggleIsFetching] = useState(false);
  const [extValid, setExtValid] = useState(true);
  const [clientImageError, setClientImageError] = useState(null);
  const [fileName, setFileName] = useState(propFileName);

  const [file, setFile] = useState(null);
  const [reupload, setReupload] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const validateFile = (file) => {
    const clientErr = getImageUploadClientError(file);
    if (clientErr) {
      alert.error(clientErr);
      setClientImageError(clientErr);
      setExtValid(false);
      return false;
    }
    setClientImageError(null);
    setExtValid(true);
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setFile(file);
      setFileName(file.name);
    };
    fileReader.readAsBinaryString(file);
    return false;
  };
  const handleOk = async () => {
    setConfirmLoading(true);
    if (!file) {
      alert.error('Please choose a file to upload');
      setConfirmLoading(false);
      return;
    }
    const clientErr = getImageUploadClientError(file);
    if (clientErr) {
      alert.error(clientErr);
      setConfirmLoading(false);
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    const res = await uploadAPI(formData);
    if (res.path) {
      if (handleStatus) {
        handleStatus(true);
      }
      changeImageLink(res.path);
      setConfirmLoading(false);
      setShowUpload(false);
      setHasUploaded(true);
    } else {
      if (handleStatus) {
        handleStatus(false);
      }
    }
  };

  const handleCancel = () => {
    setConfirmLoading(false);
    if (!hasUploaded && !reupload) {
      setFile(null);
      setFileName(null);
      setShowUpload(false);
      setReupload(false);
      setHasUploaded(false);
    } else if (reupload) {
      setHasUploaded(true);
      setShowUpload(false);
    } else {
      setHasUploaded(true);
      setShowUpload(false);
      setFileName(propFileName);
      // initFileName && setFileName(initFileName);
    }
    setExtValid(true);
    setClientImageError(null);
  };
  const handleReupload = () => {
    setReupload(true);
    setHasUploaded(false);
    setConfirmLoading(false);
  };
  const handleDelete = () => {
    setShowUpload(false);
    changeImageLink('');
    setFile(null);
    setFileName(null);
    // setInitFileName(null);
    setHasUploaded(false);
    setReupload(false);
  };
  const renderFooter = () => {
    if (!hasUploaded || props.uploadOnlyNoEditAndDelete) {
      return (
        <div>
          <Button loading={confirmLoading} onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            loading={confirmLoading}
            onClick={handleOk}
            disabled={!extValid}
          >
            Upload
          </Button>
        </div>
      );
    }
    return (
      <div>
        <Button type="primary" onClick={handleDelete}>
          delete
        </Button>
        <Button onClick={handleReupload}>reupload</Button>
      </div>
    );
  };

  useEffect(() => {
    (async () => {
      if (props.value && showUpload) {
        toggleIsFetching(true);

        setFileName(props.value);

        toggleIsFetching(false);
      }
    })();
  }, [showUpload]);
  return (
    <>
      <div
        className="upload-pdf-text"
        onClick={() => {
          setShowUpload(true);
        }}
      >
        {!hasUploaded || props.uploadOnlyNoEditAndDelete
          ? 'Upload Image'
          : 'Edit Image'}
      </div>

      <Modal
        className="upload-modal upload-img"
        title={
          !hasUploaded || props.uploadOnlyNoEditAndDelete
            ? 'Upload Image'
            : 'Edit Image'
        }
        visible={showUpload}
        // onOk={handleOk}
        onCancel={handleCancel}
        footer={renderFooter()}
      >
        {!hasUploaded || props.uploadOnlyNoEditAndDelete ? (
          <>
            <Upload.Dragger
              beforeUpload={(f) => validateFile(f)}
              maxCount={1}
              showUploadList={false}
              accept={IMAGE_UPLOAD_ACCEPT}
            >
              <span>Choose your image</span>
              <div className="upload-tips">
                <span>
                  <br />
                  1. Allowable file types: JPEG, PNG, GIF, WebP, BMP, ICO, and
                  SVG.
                  <br />
                  2. Maximum file size: 20 MB.
                  <br />
                  3. Image will automatically scale to fit report ratio size.
                  <br />
                  4. Large images may result in slower page loading times for
                  all users. Please be mindful of file size.
                </span>
              </div>
            </Upload.Dragger>
            {!extValid && clientImageError ? (
              <div className="active-color">{clientImageError}</div>
            ) : null}
          </>
        ) : null}

        {fileName ? (
          <>
            <div className="file-list">
              <Skeleton paragraph={false} active loading={isFetching}>
                {fileName.substr(
                  fileName.lastIndexOf('_') + 1,
                  fileName.length,
                )}
              </Skeleton>
            </div>
            {!extValid && clientImageError ? (
              <div className="active-color">{clientImageError}</div>
            ) : null}
          </>
        ) : null}
      </Modal>
    </>
  );
}

export default memo(UploadAndViewImage);
